export enum HoldedFieldStatusEnum {
  Pending = 'pending',
  Invalid = 'invalid',
  Configured = 'configured',
}

export const HoldedFieldStatusLabels: Record<HoldedFieldStatusEnum, string> = {
  [HoldedFieldStatusEnum.Pending]: 'Pendiente',
  [HoldedFieldStatusEnum.Invalid]: 'No encontrado en Holded',
  [HoldedFieldStatusEnum.Configured]: 'Configurado',
};
